import css from 'styled-jsx/css';

const styles = css`/* stylelint-disable declaration-property-value-whitelist */
:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.breadcrumb-and-phone-number {
    display: flex;
    justify-content: space-between;
}
h1 {
    font-size: 24px;
    margin: 0;
    margin-right: 24px;
    display: inline-block;
}
h2 {
    font-size: 24px;
}
.top-container {
    padding-top: 32px;
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
.section-wrapper {
    background: #ffffff;
}
.section-container {
    margin: 0;
    overflow: hidden;
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
}
.btn-container {
    overflow: hidden;
    padding-top: calc(calc(24px / 2) / 2);
}
.push-right {
    margin-right: calc(8px * 2);
}
.left {
    width: calc(99.9% * 3/4 - (24px - 24px * 3/4));
}
.left:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.left:last-child {
    margin-right: 0;
}
.left:nth-child(4n) {
    margin-right: 0;
    float: right;
}
.left:nth-child(4n + 1) {
    clear: both;
}
.right {
    width: calc(99.9% * 1/4 - (24px - 24px * 1/4));
    position: relative;
}
.right:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.right:last-child {
    margin-right: 0;
}
.right:nth-child(4n) {
    margin-right: 0;
    float: right;
}
.right:nth-child(4n + 1) {
    clear: both;
}
.title-col {
    width: calc(99.9% * 4/7 - (24px - 24px * 4/7));
    white-space: nowrap;
}
.title-col:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.title-col:last-child {
    margin-right: 0;
}
.title-col:nth-child(7n) {
    margin-right: 0;
    float: right;
}
.title-col:nth-child(7n + 1) {
    clear: both;
}
.mf-title-col {
    width: calc(99.9% * 3/7 - (24px - 24px * 3/7));
    white-space: nowrap;
}
.mf-title-col:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.mf-title-col:last-child {
    margin-right: 0;
}
.mf-title-col:nth-child(7n) {
    margin-right: 0;
    float: right;
}
.mf-title-col:nth-child(7n + 1) {
    clear: both;
}
.button-col-wrapper {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
    text-align: center;
}
.button-col-wrapper:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.button-col-wrapper:last-child {
    margin-right: 0;
}
.button-col-wrapper:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.button-col-wrapper:nth-child(2n + 1) {
    clear: both;
}
.button-col {
    display: inline-block;
    margin-bottom: calc(8px * 3);
    margin-left: calc(8px * 4);
}
.button-col.add-to-watchlist {
    margin-left: calc(8px * 3);
}
.two-button-col,
.button-col-wrapper {
    width: calc(99.9% * 1/3 - (24px - 24px * 1/3));
}
.two-button-col:nth-child(1n),
.button-col-wrapper:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.two-button-col:last-child,
.button-col-wrapper:last-child {
    margin-right: 0;
}
.two-button-col:nth-child(3n),
.button-col-wrapper:nth-child(3n) {
    margin-right: 0;
    float: right;
}
.two-button-col:nth-child(3n + 1),
.button-col-wrapper:nth-child(3n + 1) {
    clear: both;
}
.mf-title-col + .button-col-wrapper {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
}
.mf-title-col + .button-col-wrapper:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.mf-title-col + .button-col-wrapper:last-child {
    margin-right: 0;
}
.mf-title-col + .button-col-wrapper:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.mf-title-col + .button-col-wrapper:nth-child(2n + 1) {
    clear: both;
}
.title-sub-col {
    width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
}
.title-sub-col:nth-child(1n) {
    float: left;
    margin-right: 24px;
    clear: none;
}
.title-sub-col:last-child {
    margin-right: 0;
}
.title-sub-col:nth-child(2n) {
    margin-right: 0;
    float: right;
}
.title-sub-col:nth-child(2n + 1) {
    clear: both;
}
.button-col-wrapper.move-right {
    clear: none;
    float: right;
    width: 400px;
}
.button-col-wrapper.move-right:not(.mf-button-col) {
    width: auto;
}
.open-to-new {
    padding: 0;
    padding-right: calc(8px * 2);
    margin-top: 4px;
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 14px;
    line-height: 14px;
    color: #4c5a6a;
    white-space: nowrap;
    display: inline;
    position: absolute;
}
.asset-class {
    padding: 0;
    padding-right: calc(8px * 2);
    margin-top: 4px;
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 14px;
    line-height: 14px;
    color: #4c5a6a;
    white-space: nowrap;
    display: inline;
    position: absolute;
}
.open-to-new {
    border-right: 2px solid #4c5a6a;
    padding-left: 0;
}
.sub-container {
    display: flex;
}
.sub-header {
    margin-top: calc(24px / 2);
  font-family: 'Nimbus Sans Reg', sans-serif;
  font-size: 14px;
    margin-bottom: calc(8px * 3);
}
.sub-header div {
    line-height: 20px;
}
.alignment-container {
    clear: both;
    position: relative;
    top: calc(24px / 2);
}
.align-rt {
    text-align: right;
}
.btn {
    cursor: pointer;
    font-size: 16px;
}
.btn-lg {
    min-width: 120px;
    max-width: calc(120px * 2 + calc(8px * 2));
    width: 100%;
    color: #ffffff;
    padding: 0;
    border: 0;
    font-size: 14px;
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
}
.secondary-btn {
    color: #086ea1;
    font-weight: bold;
    border: 0;
}
.btn-active-buy {
    background-color: #e37a00;
}
.btn-disabled-buy {
  background-color: #bbbbbb;
  cursor: auto;
}
.btn-simple {
    background-color: #ffffff;
    padding: 0;
    border: 0;
    color: #086ea1;
    width: auto;
}
button {
    background-color: #ffffff;
    height: 32px;
    color: #000000;
    border: 2px solid #000000;
    border-radius: 5px;
    padding: 0;
}
.criteria-modal-link {
    border: 0;
    text-decoration: none;
    pointer-events: auto;
    font-weight: bold;
    color: #006894;
}
.prospectus-link {
    padding-top: 8px;
}
.mobile .prospectus-link {
    width: 100%;
    text-align: left;
    margin-top: 8px;
    margin-bottom: 0;
}
.call-specialist {
    position: relative;
    padding-top: calc(calc(24px / 2) / 2);
    right: 0;
  font-size: 12px;
    opacity: 0.6;
    text-align: right;
    white-space: nowrap;
}
.fund-title {
    color: #3b3b3b;
    font-size: 20px;
    font-family: 'Nimbus Sans';
    white-space: normal;
}
.button-col > :global(.add-to-watchlist-btn) {
    font-size: 16px;
}
.fund-title-ticker button {
    padding: 0;
    border: 0;
    text-align: left;
    width: -webkit-max-content;
    width: max-content;
    height: -webkit-max-content;
    height: max-content;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-size: 14px;
    color: #086ea1;
    font-weight: 700;
    cursor: pointer;
}
.fund-title-ticker button:hover {
    text-decoration: underline;
}
.fund-title-ticker span {
    font-size: 0.69em;
}
.methodology-note {
    display: inline-block;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    color: #3b4b59;
    margin-right: calc(8px * 2);
}
.methodology-note img {
    padding-right: 8px;
    position: relative;
    top: 2px;
}
.methodology-note p {
    float: right;
    margin-bottom: 0;
    color: #086ea1;
    font-weight: 700;
    cursor: pointer;
}
.divider {
    margin-left: calc(8px * 2);
    margin-right: calc(8px * 2);
}
.select-snapshot {
    border-bottom: 2px solid #086ea1;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    color: #086ea1;
    cursor: pointer;
}
h1 > span:first-of-type {
    margin-right: calc(8px * 2);
}
.fund {
    margin-bottom: calc(8px * 2);
}
.trp-name {
    text-transform: uppercase;
    font-family: 'Nimbus Sans';
    font-size: 12px;
    color: #6b7880;
}
.ph-num {
    font-family: 'Nimbus Sans';
    font-size: 14px;
    font-weight: 700;
    color: #6b7880;
    text-transform: none;
    margin-top: calc(8px * 3);
    padding-right: 44px;
}
.mf-button-col.button-col-wrapper .ph-num {
    margin-left: calc(8px * 2);
}
.ph-num a {
    color: #6b7880;
    text-decoration: none;
}
.assetclass {
    color: #ffffff;
    height: 0;
}
.notification-wrapper {
    clear: both;
    padding-top: 8px;
}
.notification-wrapper div {
    padding: 8px;
    display: inline-block;
    border-radius: 5px;
    background: #eeeeee;
    color: red;
    font-size: 12px;
}
.former-name {
    display: block;
    clear: both;
}
.former-name div {
    display: inline-block;
    background: #f7f7f7;
    font-size: 12px;
    border-radius: 5px;
    padding: 8px;
}
.snapshot-data {
    justify-content: space-around;
    margin-top: 0;
}
.snapshot-data .snapshot-top-row {
    float: left;
}
.snapshot-data .snapshot-bottom-row {
    float: left;
    padding-left: 20px;
}
.snapshot-data dd {
    margin: 0;
}
.snapshot-data .term-wrapper {
    border-right: 1px dashed #c4c4c4;
    width: -webkit-max-content;
    width: max-content;
    display: inline-block;
    padding-right: calc(8px * 2);
    padding-left: calc(8px * 2);
    vertical-align: top;
    height: calc(8px * 7);
}
.snapshot-data .mf-term-wrapper {
    border-left: 1px dashed #c4c4c4;
    display: inline-block;
    padding-right: calc(8px * 4);
    padding-left: calc(8px * 4);
    vertical-align: top;
    height: calc(8px * 7);
    float: left;
    width: 20%;
}
.snapshot-data .snapshot-bottom-row .term-wrapper:last-child {
    border-right: none;
}
.snapshot-data .term-wrapper:first-child {
    border-left: 0;
    padding-left: 0;
}
.snapshot-data .mf-term-wrapper:first-child {
    border-left: 0;
    text-align: left;
    width: 25%;
}
.snapshot-data .mf-term-wrapper.mf-nav {
    border-left: 1px dashed #c4c4c4;
    float: none;
}
.snapshot-data dt {
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #6b7880;
    padding-bottom: 8px;
}
dt.term-wrapper-etf-date {
    text-align: center;
    font-weight: 400;
    margin-top: calc(8px * 9);
    margin-left: calc(8px * 19);
    border-bottom: 1px dashed #c4c4c4;
    max-width: calc(8px * 42);
    color: #3b3b3b;
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 14px;
    padding-bottom: 8px;
}
dt.term-wrapper-mf-date {
    font-weight: 400;
    margin-top: 20px;
    margin-left: calc(8px * 9);
    max-width: calc(8px * 20);
    color: #3b3b3b;
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 12px;
    padding-bottom: 8px;
}
.hide-in-desktop {
    display: none;
}
.button-col.compare-btn {
    width: 205px;
    margin: auto;
}
.clear-fix {
    clear: both;
    width: 100%;
}
.summit-notice {
    border-radius: 5px;
    font-size: 14px;
    background: #eeeeee;
    color: #3b4b59;
    padding: calc(8px * 2);
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z' fill='white'/%3E%3Cpath d='M6.99707 16.3097H13.0024L10.0051 21.4937L6.99707 16.3097Z' fill='%23006EB8'/%3E%3Cpath d='M18.9971 16.3097H25.0024L22.0051 21.4937L18.9971 16.3097Z' fill='%2300A2C6'/%3E%3Cpath d='M10.0049 21.4937L13.0022 16.3097L15.9995 21.4937H10.0049Z' fill='%23004588'/%3E%3Cpath d='M22.0049 21.4937L25.0022 16.3097L27.9995 21.4937H22.0049Z' fill='%23009BC1'/%3E%3Cpath d='M10.0053 21.4937L6.99733 16.3097L4 21.4937H10.0053Z' fill='%23005DAC'/%3E%3Cpath d='M13.0024 16.3094H6.99707L10.0051 11.1254L13.0024 16.3094Z' fill='%23009CE0'/%3E%3Cpath d='M16 21.4937L18.9973 16.3097L22.0053 21.4937H16Z' fill='%230091BD'/%3E%3Cpath d='M13.0029 16.3097H18.9976L16.0003 21.4937L13.0029 16.3097Z' fill='%23008AAE'/%3E%3Cpath d='M18.9976 16.3094L16.0003 11.1254L13.0029 16.3094H18.9976Z' fill='%23009DC8'/%3E%3Cpath d='M22.0053 11.1254L18.9973 16.3094L16 11.1254H22.0053Z' fill='%2300AFD8'/%3E%3Cpath d='M25.0024 16.3094H18.9971L22.0051 11.1254L25.0024 16.3094Z' fill='%2300B5DA'/%3E%3Cpath d='M22.0053 11.1257L18.9973 5.95239L16 11.1257H22.0053Z' fill='%2321C1DC'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: 12px center;
    padding-left: 57px;
    overflow: hidden;
    margin-top: calc(8px * 4);
}
.summit-notice-wrapper {
    margin: 0 auto;
    margin-top: calc(8px * 2);
}
.summit-notice a {
    color: #086ea1;
}
@media (max-width: 1080px) {
    .section-container {
        padding: 0 calc(8px * 2);
    }

    .former-name {
        margin-top: calc(8px * 2);
    }
    .title-col,
    .mf-title-col,
    .button-col-wrapper,
    .mf-title-col + .button-col-wrapper {
        width: calc(99.9% * 1/1 - (24px - 24px * 1/1));
        width: 100%;
    }
    .title-col:nth-child(1n),
    .mf-title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n),
    .mf-title-col + .button-col-wrapper:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }
    .title-col:last-child,
    .mf-title-col:last-child,
    .button-col-wrapper:last-child,
    .mf-title-col + .button-col-wrapper:last-child {
        margin-right: 0;
    }
    .title-col:nth-child(1n),
    .mf-title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n),
    .mf-title-col + .button-col-wrapper:nth-child(1n) {
        margin-right: 0;
        float: right;
    }
    .title-col:nth-child(1n + 1),
    .mf-title-col:nth-child(1n + 1),
    .button-col-wrapper:nth-child(1n + 1),
    .mf-title-col + .button-col-wrapper:nth-child(1n + 1) {
        clear: both;
    }
    .title-col {
        width: calc(99.9% * 1/1 - (24px - 24px * 1/1));
        width: 100%;
        margin-bottom: calc(8px * 3);
    }
    .button-col-wrapper {
        width: calc(99.9% * 1/1 - (24px - 24px * 1/1));
        width: 100%;
        margin-bottom: calc(8px * 3);
    }
    .title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }
    .title-col:last-child,
    .button-col-wrapper:last-child {
        margin-right: 0;
    }
    .title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n) {
        margin-right: 0;
        float: right;
    }
    .title-col:nth-child(1n + 1),
    .button-col-wrapper:nth-child(1n + 1) {
        clear: both;
    }
    .mf-button-col.button-col-wrapper.move-right {
        width: 100%;
    }
    .button-col-wrapper.move-right:not(.mf-button-col) {
        width: 100%;
    }
    .hide-in-mobile {
        display: none;
    }
    .hide-in-desktop {
        display: inherit;
    }
    .trp-name {
        margin-top: calc(8px * 2);
    }
    .ph-num {
        padding-right: 0;
    }
    h1.fund.fund-title {
        margin-bottom: calc(8px * 2);
        width: 100%;
    }
    .methodology-note {
        width: 100%;
        line-height: calc(8px * 3);
    }
    span.asset-class {
        display: inherit;
        padding: 0;
        margin: 0;
    }

    img.select-funds-ribbon {
        padding-right: 8px;
        position: relative;
        top: 4px;
    }

    .secondary-btn {
        margin-left: 8px;
    }

    .prospectus-link {
        text-align: center;
    }
    dt.term-wrapper-etf-date {
        padding-bottom: 8px;
        width: calc(8px * 30);
        margin-left: calc(8px * 24);
        font-size: 12px;
    }
    .snapshot-data dt.term-wrapper-etf-date {
        font-size: 12px;
        display: block;
    }
    .snapshot-data dt.term-wrapper-mf-date {
        font-size: 12px;
        display: block;
    }
    .snapshot-data .snapshot-top-row {
        float: left;
    }
    .snapshot-data .snapshot-bottom-row {
        float: left;
        padding-left: 20px;
    }
    .snapshot-data .term-wrapper {
        flex-basis: calc(100% / 3);
        text-align: center;
    }

    .snapshot-data .mf-term-wrapper:first-child {
        width: 15%;
    }
}
@media (max-width: 720px) {
    .left,
    .right,
    .title-col,
    .mf-title-col,
    .button-col-wrapper,
    .mf-title-col + .button-col-wrapper {
        width: calc(99.9% * 1/1 - (24px - 24px * 1/1));
        width: 100%;
        white-space: normal;
    }
    .left:nth-child(1n),
    .right:nth-child(1n),
    .title-col:nth-child(1n),
    .mf-title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n),
    .mf-title-col + .button-col-wrapper:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }
    .left:last-child,
    .right:last-child,
    .title-col:last-child,
    .mf-title-col:last-child,
    .button-col-wrapper:last-child,
    .mf-title-col + .button-col-wrapper:last-child {
        margin-right: 0;
    }
    .left:nth-child(1n),
    .right:nth-child(1n),
    .title-col:nth-child(1n),
    .mf-title-col:nth-child(1n),
    .button-col-wrapper:nth-child(1n),
    .mf-title-col + .button-col-wrapper:nth-child(1n) {
        margin-right: 0;
        float: right;
    }
    .left:nth-child(1n + 1),
    .right:nth-child(1n + 1),
    .title-col:nth-child(1n + 1),
    .mf-title-col:nth-child(1n + 1),
    .button-col-wrapper:nth-child(1n + 1),
    .mf-title-col + .button-col-wrapper:nth-child(1n + 1) {
        clear: both;
    }

    .top-wrapper {
        /* @apply --mobile-view; */
        display: block;
        max-height: calc(8px * 6);
        padding: 0;
    }

    .top-container {
        /* @apply --mobile-view; */
        display: block;
        max-height: calc(8px * 6);
        padding: 0;
    }

    .button-col {
        width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
        margin-left: 0;
    }

    .button-col:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }

    .button-col:last-child {
        margin-right: 0;
    }

    .button-col:nth-child(2n) {
        margin-right: 0;
        float: right;
    }

    .button-col:nth-child(2n + 1) {
        clear: both;
    }
    .button-col:nth-child(3) {
        margin-right: 0;
    }

    .title-col {
        margin-bottom: 8px;
    }

    .mf-title-col {
        margin-bottom: 8px;
    }

    .mf-button-col.button-col-wrapper.move-right .button-col:first-child {
        margin-right: 0;
    }

    .call-specialist {
        display: none;
    }

    .trp-name {
        margin-top: calc(8px * 2);
    }

    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    .alignment-container {
        display: flex;
        margin-top: 10px;
    }

    button {
        padding: auto;
    }

    .btn-secondary {
        display: none;
    }

    .btn-lg {
        max-width: 100%;
        min-width: calc(50% - 8px);
    }

    .ph-num {
        display: none;
    }

    .snapshot-data {
        display: flex;
        flex-wrap: wrap;
    }
    .snapshot-data.mf-snapshot-pad {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-top: calc(8px * 4);
    }

    .snapshot-data .mf-term-wrapper {
        float: none;
        width: auto;
    }
    .snapshot-data .mf-term-wrapper:first-child {
        padding: 0;
    }
    .snapshot-data .mf-term-wrapper.mf-nav {
        width: auto;
        border: none;
        padding: 0;
    }

    .snapshot-data .mf-snapshot-row {
        float: left;
        padding-right: calc(8px * 5);
        border-right: 1px dashed #c4c4c4;
    }
    .snapshot-data .mf-snapshot-row:nth-child(2) {
        border: none;
        padding-left: calc(8px * 2);
    }

    .snapshot-data .snapshot-top-row {
        margin: 8px auto;
        width: 100%;
    }
    .snapshot-data .snapshot-bottom-row {
        width: 100%;
        border-top: 1px dashed #c4c4c4;
        padding-top: 20px;
        padding-left: 0;
        margin: auto;
    }

    .snapshot-data .snapshot-top-row div {
        width: 50%;
    }
    .snapshot-data .snapshot-bottom-row div {
        width: 33.33%;
    }

    .snapshot-data .fi.snapshot-top-row div {
        width: 33.33%;
    }

    .snapshot-data .snapshot-top-row .etf-exchange {
        border-right: none;
    }

    .snapshot-data .term-wrapper:first-child {
        padding-left: 10px;
        padding-right: 10px;
    }

    .snapshot-data .term-wrapper:nth-child(2) {
        padding-right: 10px;
        padding-left: 10px;
    }

    .snapshot-data .term-wrapper:nth-child(3) {
        border: none;
        margin: 0;
        padding: 0;
    }
    .snapshot-data .snapshot-bottom-row .term-wrapper:nth-child(3) {
        max-width: none;
        padding-left: calc(8px * 2);
    }

    .snapshot-data .term-wrapper:nth-child(4) {
        max-width: calc(8px * 13);
        margin: 0;
        padding-left: calc(8px * 3);
        padding-right: 0;
    }

    .snapshot-data .term-wrapper:nth-child(5) {
        max-width: calc(8px * 9);
        margin: 0;
        padding-left: calc(8px * 2);
        padding-right: 0;
    }

    .snapshot-data .mf-term-wrapper:nth-child(2) {
        padding-left: calc(8px * 9);
    }

    dt.term-wrapper-etf-date {
        padding: 0;
        width: calc(8px * 20);
        margin: 10px auto;
        margin-top: 20px;
        border: none;
        font-size: 12px;
    }

    dt.term-wrapper-mf-date {
        margin: 28px 0 auto
            auto;
    }
    .button-col.compare-btn {
        width: 170px;
    }
}
@media (max-width: 720px) and (min-width: 321.001) {
    dt.term-wrapper-etf-date {
        padding-bottom: 8px;
        width: calc(8px * 20);
        margin-left: calc(8px * 13);
        border: none;
        font-size: 12px;
    }

    dt.term-wrapper-mf-date {
        padding-bottom: 8px;
        margin-left: calc(8px * 10);
        border: none;
        font-size: 12px;
        text-align: inherit;
    }
}
@media (max-width: 320px) {
    dt.term-wrapper-etf-date {
        margin-left: calc(8px * 6);
    }

    dt.term-wrapper-mf-date {
        margin-left: calc(8px * 5);
    }

    .snapshot-data .mf-term-wrapper {
        padding-right: 0;
        padding-left: 10px;
        margin-right: calc(8px * 2);
    }

    .snapshot-data .term-wrapper:first-child {
        /* flex: 1; */
        padding-left: 10px;
        padding-right: 10px;
    }

    .snapshot-data .term-wrapper:nth-child(3) {
        border: none;
        max-width: calc(8px * 9);
        margin: 0;
        padding-right: calc(8px * 2);
    }

    .snapshot-data .term-wrapper:nth-child(4) {
        max-width: calc(8px * 13);
        margin: 0;
        padding-left: calc(8px * 2);
        padding-right: calc(8px * 3);
    }

    .snapshot-data .term-wrapper:nth-child(5) {
        max-width: calc(8px * 9);
        margin: 0;
        padding-left: calc(8px * 2);
        padding-right: 0;
    }
}
`;

export default styles;